/**
 * The confirmation that ends a notice's life (#1911): cancel.
 *
 * #1877 had two — cancel and execute — and execute was the one that changed
 * the customer catalog from a page about copy. It is gone with `/execute`
 * itself; the shelf flip lives on the SKU detail page behind a readiness
 * checklist this surface never had.
 *
 * What is left still follows the same rule the bulk send does: the dialog
 * states the consequence first and the mitigating detail second. Read the
 * other way round, "nothing is mailed" is reassurance about an action whose
 * actual effect — customers who already received it are not un-told — the
 * operator has not yet registered.
 */
import { useT } from '../../i18n/index.ts';
import { ConfirmDialog } from '../../ui/index.ts';

interface CancelProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly loading: boolean;
  readonly onConfirm: () => void;
}

export function NoticeCancelDialog({
  open,
  onOpenChange,
  loading,
  onConfirm,
}: CancelProps): JSX.Element {
  const t = useT();
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('email_notices.cancel.confirm_title')}
      body={t('email_notices.cancel.confirm_body')}
      confirmLabel={t('email_notices.cancel.confirm_action')}
      cancelLabel={t('common.cancel')}
      closeLabel={t('common.close')}
      loading={loading}
      onConfirm={onConfirm}
      testId="email-notice-cancel-confirm"
    />
  );
}
